module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img flex-b",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("password.title")))]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "regEmail"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "E-mail Address"
    },
    on: {
      "input": _vm.showButton
    },
    model: {
      value: (_vm.formInline.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "regEmail", $$v)
      },
      expression: "formInline.regEmail"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.isAgree),
      callback: function($$v) {
        _vm.isAgree = $$v
      },
      expression: "isAgree"
    }
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("password.agreeMsg")))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAgreeMessage),
      expression: "isShowAgreeMessage"
    }]
  }, [_vm._v(_vm._s(_vm.$t("password.agreeHint")))]), _vm._v(" "), _c('FormItem', {
    staticClass: "mt-3"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDisabled),
      expression: "isDisabled"
    }]
  }, [_c('v-btn', {
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("password.resetButton")))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDisabled),
      expression: "!isDisabled"
    }],
    staticClass: "mt-3 mb-3"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("password.resetButton")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "font-14"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("header.accountHint")) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signUp")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b9ea8e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Password.vue
// module id = 418
// module chunks = 0